import { createContext, useContext, useState, useEffect } from "react";

const AuthContext = createContext();

//will be used in interceptors
let logoutFn = () => {};

export const AuthProvider = ({ children, tokenStore }) => {
  const [user, setUser] = useState(() => {
    return {
      isAuthenticated: tokenStore?.isAuthenticated(),
    };
  });

  // On mount, try loading from localStorage
  useEffect(() => {
    login();
  }, []);

  const isAuthenticated = () => user.isAuthenticated;

  const logout = () => {
    setUser({ isAuthenticated: false, role: "" });
  };

  const login = () => {
    const isAuthenticated = tokenStore.isAuthenticated();
    setUser({ isAuthenticated: isAuthenticated });
  };

  // Assign the logout function to the external variable
  logoutFn = logout;

  return (
    <AuthContext.Provider value={{ user, setUser, login, isAuthenticated }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
export const triggerLogout = () => logoutFn();
